<template>
    <div class="filters-options d-flex justify-content-between align-items-center">
        <button class="filters-toggle filters-toggle-btn d-flex me-3"
                @click.prevent=" store.commit( 'toggleFiltersVisibility' ) "
                :aria-label=" openCloseFiltersText "
                :tabindex="!filtersOpen && isMobile ? -1 : 0"
        ><i class="fa-light fa-sliders" aria-hidden="true"></i><span
            class="filter-toggle-label ms-2"
        >{{ copydeck.filters.fr }}</span></button>

        <div class="d-flex align-items-center">
            <button type="button"
                    @click.prevent="clearAll"
                    :class="cssClassClearAll"
                    class="filters-reset"
                    :disabled="!hasFilter"
                    :aria-hidden="!filtersOpen"
                    :tabindex="filtersOpen ? 0 : -1"
            > {{
                    copydeck.effacer_tout.fr
                }}<span class="sr-only"> tous les filtres sélectionnés</span>
            </button>
            <span class="filters-pipe">|</span>
            <button type="button"
                    @click.prevent="toggleExpandCollapse"
                    :aria-label="btnExpandCollapseA11y"
                    class="filters-expand"
                    :tabindex="filtersOpen ? 0 : -1">{{
                    btnExpandCollapse
                }}
            </button>
            <button type="button" class="sr-only-focusable" id="btn-jump-to-results" @click="jumpToResults" :tabindex="!filtersOpen && isMobile ? -1 : 0">Sauter aux
                résultats
            </button>
        </div>

    </div>
</template>

<script setup>


import { ref, computed } from "vue";
import { useStore }      from "vuex";

let store = useStore();

let emits = defineEmits( [ "expand-all", "collapse-all", "clear-filters" ] );

let copydeck          = computed( () => store.state.copydeck );
let collapsed         = ref( true );
let btnExpandCollapse = computed( () => collapsed.value ? (copydeck.value.btn_developper?.fr ?? '') : (copydeck.value.btn_reduire?.fr ?? '') );
let btnExpandCollapseA11y = computed( () => collapsed.value ? (copydeck.value.btn_developper_a11y?.fr ?? '') : (copydeck.value.btn_reduire_a11y?.fr ?? '') );
let hasFilter         = computed( () => store.state.checked.length > 0 );
let hasSearchTerm     = computed( () => (store.state.searchTerms ?? "").length > 0 );
let cssClassClearAll  = computed( () => hasFilter.value || hasSearchTerm.value ? "" : "disabled" );

let filtersOpen = computed( () => store.getters.areFiltersOpen );
let isMobile    = computed( () => store.getters.isMobile );

// a11y
let openCloseFiltersText = computed( () =>
{
    return store.getters.areFiltersOpen
        ? (copydeck?.value?.a11yFiltersHide?.fr ?? 'copydeck.search.a11yFiltersHide.fr')
        : (copydeck?.value?.a11yFiltersShow?.fr ?? 'copydeck.search.a11yFiltersShow.fr');
} );


function clearAll ()
{
    if ( hasFilter.value || hasSearchTerm.value )
    {
        emits( 'clear-filters' )
    }
}

function toggleExpandCollapse ()
{
    collapsed.value = !collapsed.value;

    (collapsed.value) ? emits( 'collapse-all' ) : emits( 'expand-all' );

}


function jumpToResults ()
{

    const resultsTop = document.querySelector( '.search-results .results-info .num-results' );
    if ( resultsTop )
    {
/*console.log(('jumpToResults', isMobile.value ))*/;        if ( isMobile.value )
        {
            store.commit( 'toggleFiltersVisibility' );
        }

        resultsTop.focus();
    }
}

</script>

<style scoped>

</style>
